import React, { useState, useEffect } from "react";
import { GameContainer, GameWrapper } from "../AppStyled";

import Header from "./gamePlay/header/Header";
import Card from "./gamePlay/gameBoard/Card";
import Subtext from "./gamePlay/subText/Subtext";
import Footer from "./gamePlay/footer/Footer";
import useSound from "use-sound";
import SetBet from "./otherPages/setBet/SetBet";
import DetailedHistory from "./otherPages/detailedHistory/DetailedHistory";

import Settings from "./otherPages/settings/Settings";
import GameRules from "./otherPages/gameRules/GameRules";
import History from "./otherPages/history/History";
import ProvFair from "./otherPages/provablyFair/ProvFair";
import BetReply from "./otherPages/betReply/BetReply";
import { ReactComponent as ClubSVG } from "../assets/suits/club.svg";
import { ReactComponent as SpadeSVG } from "../assets/suits/spade.svg";
import { ReactComponent as DiamondSVG } from "../assets/suits/diamond.svg";
import { ReactComponent as HeartSVG } from "../assets/suits/heart.svg";

import backgroundSFX from "../assets/audio/globals/backgroundSFX.mp3";
import winSFX from "../assets/audio/hilo/winSFX.mp3";
import { Cards } from "./helpers/getCards";
import useGlobalSounds from "./shared/audio/globalAudio";
import useLoading from "./loading/useLoading";
import Loading from "./loading/Loading";

const Suits = [<SpadeSVG />, <ClubSVG />, <HeartSVG />, <DiamondSVG />];

export default ({
  balance,
  bet,
  volumeLocal,
  above,
  handleAbove,
  handleBetAmount,
  gameIsOn,
  inactiveGame,
  cashout,
  stateRound,
  provablyFairSeeds,
  handleNotification,
  rotateBtnDisable,
  userInfo,
  notifyText,
  handleCashout,
  handleStartRound,
  handleChange,
  handleStepRound,
  handleEndRound,
  history,
  Globals,
  picks,
  result,
  userSettings,
  cardHistory,
  saveUserSettings,
  handleIsDisabled,
  isDisabled,
  winSound,
  getBetReply,
  betReply,
  userId,
  handleVolumeLocal,
  handleWaitForResult,
  gameStates,
  cardChange,
  pageNotFound,
}) => {
  const [color, setColor] = useState("");
  const [cardSymbol, setCardSymbol] = useState("");
  const [cardSuit, setCardSuit] = useState(null);
  const [aboveAnim, setAboveAnim] = useState(false);
  const [settingsAnim, setSettingsAnim] = useState(false);
  const [prevCard, setPrevCard] = useState(false);
  const [roundID, setRoundID] = useState("");

  const handleRoundID = (i) => setRoundID(i);
  let currCard = Cards[stateRound.currentCard];
  const [playWinSFX] = useSound(winSFX, {
    volume: userSettings.volume,
  });

  useEffect(() => {
    if (currCard && (currCard.includes("D") || currCard.includes("H"))) {
      setColor("red");
    } else {
      setColor("black");
    }
  }, [currCard]);

  const { AUDIO } = useGlobalSounds(userSettings.volume, userSettings.sound);
  useEffect(() => {
    if (currCard) {
      switch (currCard.charAt(0)) {
        case "S":
          setCardSuit(Suits[0]);
          break;
        case "C":
          setCardSuit(Suits[1]);
          break;
        case "H":
          setCardSuit(Suits[2]);
          break;
        case "D":
          setCardSuit(Suits[3]);
          break;

        default:
          break;
      }
    }
  }, [currCard]);

  useEffect(() => {
    if (currCard) {
      if (currCard.length === 2 && currCard.charAt(1) === "1") {
        setCardSymbol("A");
      } else {
        switch (currCard.charAt(2)) {
          case "0":
            setCardSymbol("10");
            break;
          case "1":
            setCardSymbol("J");
            break;
          case "2":
            setCardSymbol("Q");
            break;
          case "3":
            setCardSymbol("K");
            break;
          default:
            setCardSymbol(currCard.charAt(1));
            break;
        }
      }
    }
  }, [currCard]);
  function floorFigure(figure, decimals) {
    // if (!decimals) decimals = 2;
    var d = Math.pow(10, decimals);
    return (parseInt(figure * d) / d).toFixed(decimals);
  }

  const handleAboveAnimation = (e) => {
    setAboveAnim(e);
  };
  const handleSettingsAnimation = (e) => {
    setSettingsAnim(e);
  };

  const handleCardChange = (e) => {
    if (!e) {
      setPrevCard(false);
      clearTimeout();
    } else {
      setPrevCard(e);
      setTimeout(() => {
        setPrevCard(false);
      }, 550);
    }
  };
  // audio
  useEffect(() => {
    if (winSound && userSettings.sound === "1") {
      playWinSFX();
    }
  }, [winSound, playWinSFX, userSettings.sound]);

  /* <<<<<< background music >>>>>> */

  // set music is on/off for looping background music
  const [musicIsOn, setMusicIsOn] = useState(false);

  const [play, { stop }] = useSound(backgroundSFX, {
    volume: volumeLocal,
    onend: () => setMusicIsOn(true),
  });



  const enableLoading = false
  const [isLoaded, setisLoaded] = useState(false)
  const pages = [
    "settings",
    "gameRules",
    "provFair",
    "history",
    "setBet",
    'detailedHistory'
  ]
  const loadedPages = enableLoading ? [] : pages

  const [arePagesLoaded, duration] = useLoading(handleAbove, loadedPages)
  useEffect(() => {
    setisLoaded(arePagesLoaded)
  }, [arePagesLoaded, userId, setisLoaded])

  // stop music before initialize, if error occures or if music is off
  useEffect(() => {
    if ((userSettings.music === "1" || musicIsOn) && isLoaded) {
      stop();
      play();
      setMusicIsOn(false);
    } else {
      stop();
    }
    return function cleanup() {
      stop();
    };
  }, [play, stop, userSettings.music, musicIsOn, isLoaded]);

  return (
    <>
      {isLoaded ? <div>
        <GameContainer className="GamePlay" isDisabled={isDisabled}>
          <GameWrapper blur={above} aboveA={aboveAnim || settingsAnim}>
            <Header
              handleAbove={handleAbove}
              balance={balance}
              handleSettingsAnimation={handleSettingsAnimation}
              userInfo={userInfo}
              floorFigure={floorFigure}
              audio={AUDIO.goForward}
            />
            <Card
              handleChange={handleChange}
              stateRound={stateRound}
              color={color}
              cardSuit={cardSuit}
              cardSymbol={cardSymbol}
              rotateBtnDisable={rotateBtnDisable}
              isDisabled={isDisabled}
              handleIsDisabled={handleIsDisabled}
              cardChange={cardChange}
              prevCard={prevCard}
              result={result}
              handleCardChange={handleCardChange}
              audio={AUDIO.randomCard}
            />
            <Subtext
              handleAbove={handleAbove}
              gameIsOn={gameIsOn}
              picks={picks}
              result={result}
              stateRound={stateRound}
              floorFigure={floorFigure}
              handleAboveAnimation={handleAboveAnimation}
              userSettings={userSettings}
              cardChange={cardChange}
              gameStates={gameStates}
              audio={AUDIO.goForward}
            />
            <div>{userInfo.currency}</div>
            <Footer
              bet={bet}
              userInfo={userInfo}
              handleAbove={handleAbove}
              handleBetAmount={handleBetAmount}
              gameIsOn={gameIsOn}
              inactiveGame={inactiveGame}
              cashout={cashout}
              stateRound={stateRound}
              handleCashout={handleCashout}
              handleStartRound={handleStartRound}
              handleEndRound={handleEndRound}
              handleStepRound={handleStepRound}
              floorFigure={floorFigure}
              cardSymbol={cardSymbol}
              handleAboveAnimation={handleAboveAnimation}
              handleNotification={handleNotification}
              handleIsDisabled={handleIsDisabled}
              isDisabled={isDisabled}
              handleCardChange={handleCardChange}
              userSettings={userSettings}
              handleWaitForResult={handleWaitForResult}
              gameStates={gameStates}
              audio={AUDIO}
            />
          </GameWrapper>
        </GameContainer>
        {above === "settings" && (
          <Settings
            saveUserSettings={saveUserSettings}
            userSettings={userSettings}
            handleAbove={handleAbove}
            settingsAnim={settingsAnim}
            handleAboveAnimation={handleAboveAnimation}
            handleSettingsAnimation={handleSettingsAnimation}
            volumeLocal={volumeLocal}
            handleVolumeLocal={handleVolumeLocal}
            audio={AUDIO}
          />
        )}
        {above === "provFair" && (
          <ProvFair
            handleAbove={handleAbove}
            Globals={Globals}
            handleNotification={handleNotification}
            gameIsOn={gameIsOn}
            pf={provablyFairSeeds}
            aboveAnim={aboveAnim}
            handleAboveAnimation={handleAboveAnimation}
            audio={AUDIO}
          />
        )}
        {above === "gameRules" && (
          <GameRules
            handleAbove={handleAbove}
            aboveAnim={aboveAnim}
            handleAboveAnimation={handleAboveAnimation}
            audio={AUDIO.goBack}
            userInfo={userInfo}
          />
        )}
        {above === "history" && (
          <History
            handleAbove={handleAbove}
            floorFigure={floorFigure}
            history={history}
            aboveAnim={aboveAnim}
            handleAboveAnimation={handleAboveAnimation}
            handleNotification={handleNotification}
            getBetReply={getBetReply}
            userId={userId}
            betReply={betReply}
            notifyText={notifyText}
            pageNotFound={pageNotFound}
            handleRoundID={handleRoundID}
            audio={AUDIO}
            userInfo={userInfo}
          />
        )}
        {above === "setBet" && (
          <SetBet
            handleAbove={handleAbove}
            bet={bet}
            handleBetAmount={handleBetAmount}
            handleNotification={handleNotification}
            userInfo={userInfo}
            aboveAnim={aboveAnim}
            handleAboveAnimation={handleAboveAnimation}
            userSettings={userSettings}
            audio={AUDIO}
          />
        )}
        {above === "detailedHistory" && (
          <DetailedHistory
            handleAbove={handleAbove}
            aboveAnim={aboveAnim}
            handleAboveAnimation={handleAboveAnimation}
            cardHistory={cardHistory}
            floorFigure={floorFigure}
            audio={AUDIO.confirm}
          />
        )}
        {above === "betReply" && (
          <BetReply
            handleAbove={handleAbove}
            aboveAnim={aboveAnim}
            handleAboveAnimation={handleAboveAnimation}
            cardHistory={cardHistory}
            floorFigure={floorFigure}
            betReply={betReply}
            precision={userInfo.precision}
            handleNotification={handleNotification}
            roundID={roundID}
            audio={AUDIO}
          />
        )}
      </div> :
        <Loading duration={duration} />
      }
    </>
  );
};
